import {
  FirestoreDataConverter,
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from "firebase/firestore";

import { DraftFieldType } from "@api";

export const draftFieldConverter: FirestoreDataConverter<DraftFieldType> = {
  toFirestore(data: DraftFieldType): DocumentData {
    return data;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options?: SnapshotOptions,
  ): DraftFieldType {
    return snapshot.data(options) as DraftFieldType;
  },
};
